<script setup lang="ts">
import { useDialogPluginComponent } from 'quasar';
import { useSlots } from 'vue';

defineProps<{
    title?: string;
    enableClearAllBtn: boolean;
    enableActionBtns: boolean;
}>();

useSlots();

const {
    dialogRef,
    onDialogHide,
} = useDialogPluginComponent();

defineExpose({
    dialogRef,
    onDialogHide,
});

defineEmits([
    ...useDialogPluginComponent.emits,
    'clear-all',
    'cancel',
    'apply',
]);

</script>

<template>
    <q-dialog
        ref="dialogRef"
        position="bottom"
        @hide="onDialogHide"
    >
        <q-card class="q-dialog-plugin">
            <!-- 1st Row: Close Button, Title, Clear All Button -->
            <q-card-section class="q-dialog__title bg-fsum-all-blue row items-center">
                <q-btn
                    v-close-popup
                    icon="close"
                    flat
                    round
                    dense
                    class="col-auto text-left"
                />
                <div class="title text-center text-center col">
                    {{ title }}
                </div>

                <q-btn
                    v-if="enableClearAllBtn"
                    v-close-popup
                    flat
                    no-caps
                    dense
                    label="Clear All"
                    class="clear-all-button anchor-button text-fsum-med-blue col-auto text-right"
                    @click="$emit('clear-all')"
                />
            </q-card-section>

            <!-- 2nd Row: Content -->
            <q-card-section class="dialog-content">
                <q-scroll-area class="dialog-content-scroll">
                    <slot />
                </q-scroll-area>
            </q-card-section>

            <!-- 3rd Row: Cancel and Apply Buttons (Optional) -->
            <q-card-section
                v-if="enableActionBtns"
                class="dialog-actions"
            >
                <div class="row justify-end button-group q-px-md q-py-md q-gutter-x-sm">
                    <q-btn
                        v-close-popup="true"
                        label="Cancel"
                        class="fsum-button-outlined q-px-sm"
                        no-caps
                        dense
                        flat
                        @click="$emit('cancel')"
                    />
                    <q-btn
                        v-close-popup="true"
                        label="Apply"
                        class="fsum-button-dark-blue q-px-sm"
                        no-caps
                        dense
                        flat
                        @click="$emit('apply')"
                    />
                </div>
            </q-card-section>
        </q-card>
    </q-dialog>
</template>

<style scoped>
.q-dialog-plugin {
    display: grid;
    grid-template-rows: auto 1fr auto;
    max-height: 60vh;
    overflow: hidden;
}
.q-dialog__title.title {
    font-size: 14px;
}
.dialog-actions {
    border-top: 1px solid var(--fsum-gray4);
}
.dialog-content {
    display: flex;
    min-height: 250px;
    width: 100%;
    padding: 0;
}
.dialog-content-scroll {
    flex: 1 1 1px;
}

</style>
